import { Flex } from 'foundations-components/components/Flex';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { AILoader } from 'ai-components-ui-library/components/loading/AILoader';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { useExperiment, TrackWhen } from '../../experiments/useExperiment';
import { useGTKMDomainHelperTextKey } from '../../hooks/useGTKMDomainHelperText';
import { isAssignedToGTKMExperiment } from '../../utils/gtkm/isAssignedToGTKM';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SidePanelCompanyDomainLoading = () => {
  const {
    isGTKMAnimationRunning,
    copyMessageKey
  } = useGTKMDomainHelperTextKey();
  const {
    isAssignedToSpecificVariant: isAssignedToACQ173Variant
  } = useExperiment(ExperimentKeys.ACQ0173, TrackWhen.never);
  const {
    isAssignedToSpecificVariant: isAssignedToACQ175Variant
  } = useExperiment(ExperimentKeys.ACQ0175, TrackWhen.never);
  const {
    isAssignedToSpecificVariant: isAssignedToACQ177Variant
  } = useExperiment(ExperimentKeys.ACQ0177, TrackWhen.never);
  const isAssignedToACQ177VariantA = isAssignedToACQ177Variant(ExperimentParameterGroup.Variant_A);
  const isAssignedToACQ173VariantA = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_A);
  const isAssignedToACQ173VariantC = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_C);
  const isAssignedToACQ175VariantA = isAssignedToACQ175Variant(ExperimentParameterGroup.Variant_A);
  const isAssignedToGTKM = useSelector(isAssignedToGTKMExperiment);
  const notAssignedToSpecificExperiment = !isAssignedToACQ173VariantA && !isAssignedToACQ173VariantC && !isAssignedToACQ175VariantA && !isAssignedToACQ177VariantA;
  const AnimationNotLoadedForGTKM = isAssignedToGTKM && !isGTKMAnimationRunning;
  if (notAssignedToSpecificExperiment || AnimationNotLoadedForGTKM) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": "company-domain-footer",
    gap: "100",
    justifyContent: "center",
    marginBlockEnd: "auto",
    marginBlockStart: "auto",
    marginInlineEnd: "400",
    children: [/*#__PURE__*/_jsx(AILoader, {
      isFinished: !isGTKMAnimationRunning,
      size: "xs"
    }), /*#__PURE__*/_jsx(Text, {
      as: "small",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: copyMessageKey
      })
    })]
  });
};
export default SidePanelCompanyDomainLoading;